// extracted by mini-css-extract-plugin
module.exports = {"layout":"video_layout__RZT4k","videoContainer":"video_videoContainer__sGoro","content":"video_content__fpElM","bgLower":"video_bgLower__4C5T0"};